<template>
  <div class="page page-project">
    <div class="fit v-px-md">
      <a-tabs type="card" v-model="tab" @change="handleTabChange">
        <a-tab-pane key="project" tab="项目统计"></a-tab-pane>
        <a-tab-pane key="amount" tab="捐赠金额统计" force-render></a-tab-pane>
        <div slot="tabBarExtraContent">
          <a-select v-model="projectRange" :default-value="1" placeholder="统计范围" style="width: 200px" @change="onChangeProjectRange" v-if="tab === 'project'">
            <a-select-option :value="1">统计 - 今年新增项目</a-select-option>
            <a-select-option :value="2">统计 - 进行中的项目</a-select-option>
            <a-select-option :value="3">统计 - 全部项目</a-select-option>
          </a-select>
        </div>
      </a-tabs>
      <!-- <router-view></router-view> -->
      <compontent :is="currentTabComponent" ref="stat" />
    </div>
  </div>
</template>

<script>
import ProjectStat from './project'
import AmountStat from './amount'
export default {
  namne: 'StatIndex',
  data() {
    return {
      tab: undefined,
      currentTabComponent: null,
      projectRange: 1,
    }
  },
  watch: {
    $route() {
      this.tab = this.$route.query.tab || 'started'
    },
    tab(key) {
      if (key === 'project') {
        this.currentTabComponent = ProjectStat
        this.projectRange = 1
      } else if (key === 'amount') {
        this.currentTabComponent = AmountStat
      }
    },
  },
  methods: {
    initTabKey() {
      let { path } = this.$route
      this.tab = path.substring(path.lastIndexOf('/') + 1)
    },
    handleTabChange(key) {
      this.$router.push({ path: 'stat', query: { tab: key } })
    },
    onChangeProjectRange(range) {
      this.$refs.stat.loadStatinfo(range)
    },
  },
  mounted() {
    this.tab = this.$route.query.tab || 'project'
  },
}
</script>
